import $ from 'jquery';
import GeoLocation from './GeoLocation.mjs';
import Autocomplete from './Autocomplete.mjs';
import Storage from './Storage.mjs';
import {geocodeData, handleInputEvents, setInputValue} from './FormSearch.mjs';
import LoadingIndicator from './LoadingIndicator.mjs';
import Alert from './Alert.mjs';

export default class Directions {
  constructor(form) {
    this.$form = $(form);
    this.$input = this.$form.find('.js_directions-input');
    this.$errorWrapper = this.$form.find('.js_form-search-error');
    this.geocoderIsRunning = false;

    handleInputEvents.call(this);
    initGeoLocation.call(this);
    initAutocomplete.call(this);
    prefillInput.call(this);
  }

  addAlert($alert) {
    LoadingIndicator.hide();
    this.$errorWrapper.html($alert);
  }

  removeAlert() {
    this.$errorWrapper.empty();
  }
}

function initGeoLocation() {
  return new Promise((resolve) => {
    new GeoLocation(
      this.$form.find('.js_form-search-location'),
      (data) => {
        this.removeAlert();
        geocodeData.call(this, handleGeocoderResult, data);
      },
      (error) => {
        this.addAlert(new Alert({
          'typeWarning': true,
          'iconId': 'exclamation',
          'copytext': error,
        }));
      },
    );

    resolve();
  });
}

function initAutocomplete() {
  return new Promise((resolve) => {
    new Autocomplete(
      this.$input,
      null,
      geocodeData.bind(this, handleGeocoderResult)
    );

    resolve();
  });
}

function prefillInput() {
  const lastSearch = Storage.getItem('lastSearch');

  if (lastSearch) {
    setInputValue.call(this, lastSearch.name);
  }
}

function handleGeocoderResult({results}) {
  LoadingIndicator.hide();

  if (results.length < 1) {
    this.$input.val('');
    return;
  }

  // Get nearest address
  const name = results[0]['formatted_address']
  setInputValue.call(this, name);
  this.geocoderIsRunning = false;
}
